var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "translate(0, -1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33315 4.33301C1.96496 4.33301 1.66649 4.63148 1.66649 4.99967V10.9997C1.66649 11.3679 1.96496 11.6663 2.33315 11.6663H11.6665C12.0347 11.6663 12.3332 11.3679 12.3332 10.9997V4.99967C12.3332 4.63148 12.0347 4.33301 11.6665 4.33301H2.33315ZM0.333152 4.99967C0.333152 3.89511 1.22858 2.99967 2.33315 2.99967H11.6665C12.7711 2.99967 13.6665 3.89511 13.6665 4.99967V10.9997C13.6665 12.1042 12.7711 12.9997 11.6665 12.9997H2.33315C1.22858 12.9997 0.333152 12.1042 0.333152 10.9997V4.99967Z",
    fill: "#818181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66649 1.66634C5.48967 1.66634 5.32011 1.73658 5.19508 1.8616C5.07006 1.98663 4.99982 2.1562 4.99982 2.33301V3.66634C4.99982 4.03453 4.70134 4.33301 4.33315 4.33301C3.96496 4.33301 3.66649 4.03453 3.66649 3.66634V2.33301C3.66649 1.80257 3.8772 1.29387 4.25227 0.918794C4.62735 0.543721 5.13605 0.333008 5.66649 0.333008H8.33315C8.86359 0.333008 9.37229 0.543721 9.74737 0.918794C10.1224 1.29387 10.3332 1.80257 10.3332 2.33301V3.66634C10.3332 4.03453 10.0347 4.33301 9.66649 4.33301C9.2983 4.33301 8.99982 4.03453 8.99982 3.66634V2.33301C8.99982 2.1562 8.92958 1.98663 8.80456 1.8616C8.67953 1.73658 8.50996 1.66634 8.33315 1.66634H5.66649Z",
    fill: "#818181"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99982 6.33301C7.36801 6.33301 7.66649 6.63148 7.66649 6.99967V7.00634C7.66649 7.37453 7.36801 7.67301 6.99982 7.67301C6.63163 7.67301 6.33315 7.37453 6.33315 7.00634V6.99967C6.33315 6.63148 6.63163 6.33301 6.99982 6.33301Z",
    fill: "#818181"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.404467 7.36634C0.570152 7.03754 0.971015 6.9053 1.29982 7.07099C3.06782 7.96189 5.02004 8.42596 6.99982 8.42596C8.9796 8.42596 10.9318 7.96189 12.6998 7.07099C13.0286 6.9053 13.4295 7.03754 13.5952 7.36634C13.7609 7.69515 13.6286 8.09601 13.2998 8.26169C11.3457 9.24637 9.188 9.75929 6.99982 9.75929C4.81164 9.75929 2.65393 9.24637 0.699819 8.26169C0.371015 8.09601 0.238781 7.69515 0.404467 7.36634Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.04273503fa2a190f76e2dd059eea5289.svg";
export { ForwardRef as ReactComponent };